module.exports = __webpack_public_path__ + "static/media/Pidove_gaussian2.abfbbb94.png";